import { render, staticRenderFns } from "./TransportTable.vue?vue&type=template&id=e28b0be4"
import script from "./TransportTable.vue?vue&type=script&lang=js"
export * from "./TransportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports